import React from 'react'
import ReactModal from 'react-modal'
import styles from './tcmodal.module.scss'

export default function TCModal({ isOpen, close }) {
  return (
    <ReactModal
      isOpen={isOpen}
      overlayClassName={styles.modalOverlay}
      className={styles.modal}
      onRequestClose={() => close()}
    >
      <section className={styles.header}>
        <div className={styles.closeButton} onClick={() => close()}>
          <img src="/close-modal-grey.svg" alt="close icon" />
        </div>
        <h1 className={styles.title}>
          MAWOO PETS REFERRAL PROGRAM TERMS & CONDITIONS
        </h1>
      </section>
      <div className={styles.container}>
        <ol>
          <li className={styles.text}>
            <strong>Program Overview </strong>The Mawoo Pets Referral Program
            (hereinafter referred to as "the Program") offers registered users
            ("Referrers") the opportunity to earn rewards by referring friends
            and family ("Referees") to purchase puppies from the Mawoo Pets
            website.
          </li>
          <li className={styles.text}>
            <strong>Eligibility </strong>Participants must be legal residents of
            their respective countries and be at least the age of majority in
            their jurisdiction of residence. Employees, officers, directors,
            agents, and representatives of Mawoo Pets and its affiliates are not
            eligible to participate.
          </li>
          <li className={styles.text}>
            <strong>Referral Reward </strong>For each qualified referral, the
            Referrer will receive an Amazon gift card valued at $75. The Referee
            will receive a discount of $75 on their first purchase. Referral
            rewards are subject to verification and will not be awarded if the
            referral is not in compliance with these Terms and Conditions.
          </li>
          <li className={styles.text}>
            <strong>Qualified Referral </strong>A qualified referral is defined
            as a purchase made at{' '}
            <a className={styles.link} href="https://www.mawoopets.com/">
              www.mawoopets.com
            </a>{' '}
            by a person (a "Referred Customer") who makes a purchase on our
            website by entering the Referrer's unique referral code. The
            Referred Customer and the Referrer cannot be the same person (for
            example, by using a different email address).
          </li>
          <li className={styles.text}>
            <strong>Reward Payment </strong>All rewards will be payable within
            60 days following the completion of a qualified referral's purchase.
            Referrers will receive their Amazon gift card reward via email.
          </li>
          <li className={styles.text}>
            <strong>Non-Transferability </strong> Referral rewards cannot be
            transferred, exchanged, sold, or otherwise changed.
          </li>
          <li className={styles.text}>
            <strong>Compliance with Laws </strong>Participants in the Program
            must comply with all up-to-date laws, rules, and regulations. The
            Program is void where prohibited by law.
          </li>
          <li className={styles.text}>
            <strong>Program Termination and Changes </strong>Mawoo Pets reserves
            the right to suspend or terminate the Program or to change these
            Terms and Conditions at any time and for any reason.
          </li>
          <li className={styles.text}>
            <strong>Limitation of Liability </strong>Mawoo Pets is not
            responsible for any incorrect or inaccurate information supplied by
            participants while participating in the Program.
          </li>
          <li className={styles.text}>
            <strong>Privacy </strong>Personal information collected from
            participants will be used by Mawoo Pets for the purpose of
            administering the Program and in accordance with Mawoo Pets'{' '}
            <a
              className={styles.link}
              href={`${process.env.NEXT_PUBLIC_ROOT_URL}/policy`}
            >
              Privacy Policy
            </a>
            .
          </li>
        </ol>
      </div>
    </ReactModal>
  )
}
